<template>
  <div>
    <div class="d-flex justify-content-begin m-2 m-sm-0">
      <PeriodDropdown
        style="max-width: 100px;"
        v-if="periods && periods.length > 1"
      />
      <CompanyDropdown
        class="ml-4"
        :company_id="company_id"
      />
      
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import {
  SET_TITLES
} from '@/core/services/store/common.module';

import { setCurrentPeriodId, setCompanyList, getCurrentPeriods, getCurrentPeriod } from '@/core/services/companyAccess';
import { setCurrentCompanyId } from '@/core/services/initUserMemlist';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import PeriodDropdown from './PeriodDropdown.vue'
import CompanyDropdown from './CompanyDropdown.vue'

export default {
  name: 'UserDropdowns',
  components: {
    PeriodDropdown,
    CompanyDropdown
  },
  data() {
    return {
      
      period: {},
      company: {},
      filterText: '',
      filtered: [],
      initialized: false
    };
  },
  props: {
    company_id: { type: String, default: '' },
  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters([
      'companies',
      'currentUserId',
      'currentUser',
      'periods',
      'currentCompanyId',
      'currentPeriodId',
      'sid'
    ]),

  },
  mounted() {
    
  },
  watch: {
    
  },
  methods: {

    
  }
};
</script>
